import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import { panelSnapTranslocationState } from "~/containers/LegacyDesigner/state/elements/panels"
import { zoomState } from "~/containers/LegacyDesigner/state/view"

const ActiveSnapPoint: FC = () => {
  const zoom = useRecoilValue(zoomState)
  const panelSnapTranslocation = useRecoilValue(panelSnapTranslocationState)

  return (
    <>
      {[
        panelSnapTranslocation.pointPairs.x?.p1,
        panelSnapTranslocation.pointPairs.x?.p2,
      ].map((point, idx) => {
        if (!point) return null
        const screenPoint = studioToScreen.point(point, zoom)

        return (
          <circle
            key={JSON.stringify(point) + idx}
            cx={screenPoint.x}
            cy={screenPoint.y}
            r="5"
            fill="#0f0"
          />
        )
      })}
    </>
  )
}

export default ActiveSnapPoint
